import React, { useMemo } from 'react';
import * as Styled from './proposal-section.styles';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { LabeledCheckbox } from '@shared-mui-components';
import { InfoTooltip } from '@shared-components';
import { CandidateStatusListItem } from '@innowise-group/core';
import { FormItemTypes } from '@constants';

interface ProposalSectionProps {
  statusConfig?: CandidateStatusListItem;
}

const ProposalSection: React.FC<ProposalSectionProps> = ({ statusConfig }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const isOnInterview = useMemo(
    () => !!statusConfig?.formItems.find((item) => item.item === FormItemTypes.IS_ON_INTERVIEW),
    [statusConfig],
  );

  return (
    <Styled.ProposalSectionWrapper>
      {isOnInterview && (
        <Styled.CheckBoxWrapper>
          <Controller
            name="isOnInterview"
            control={control}
            render={({ field: { onChange, value }, formState: { errors } }) => (
              <LabeledCheckbox
                onChange={onChange}
                checked={value}
                label={t('tooltips.goingOnInterviews')}
                error={!!errors?.isOnInterview?.message}
              />
            )}
          />
        </Styled.CheckBoxWrapper>
      )}

      <Styled.CheckBoxWrapper>
        <Controller
          name="offerChecked"
          control={control}
          render={({ field: { onChange, value }, formState: { errors } }) => {
            return (
              <LabeledCheckbox
                onChange={onChange}
                checked={value}
                label={t('tooltips.offerChecked')}
                error={!!errors?.offerChecked?.message}
              />
            );
          }}
        />
        <InfoTooltip placement="top-end" title={t('tooltips.offerStatusInfo')} />
      </Styled.CheckBoxWrapper>
    </Styled.ProposalSectionWrapper>
  );
};

export default ProposalSection;
